import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1beadf24&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=1beadf24&lang=css"

import exportComponent from "/Users/huangzexu/Code/Vue/Yiban/yiban/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1beadf24"]])

export default __exports__